import type { CategorySchema } from '~/types/schema';

export const processCategories = (
  libraryBookId: string,
  items: CategorySchema[]
) => {
  const virtualParentCategories = [];
  const mCategories = {};

  const clean = (item: CategorySchema) => {
    const baseItem = item as any;
    delete baseItem.categories;
    delete baseItem.tags;
    delete baseItem.type;
    delete baseItem.hasAdaptiveEssentials;
    delete baseItem.parentPublished;
    delete baseItem.textToSpeech;
    delete baseItem.payload;
    delete baseItem.essentialsArray;
    delete baseItem.annalsArray;
    return baseItem;
  };

  items.forEach((item: CategorySchema) => {
    if (item.virtualChildren) {
      virtualParentCategories.push(item);
      // switchToVirtualChildren(item);
    }
    item = clean(item);
    mCategories[item.id] = item;
  });

  virtualParentCategories.forEach((item: CategorySchema) => {
    const { virtualChildren } = item;
    virtualChildren.forEach((vChildren) => {
      if (
        mCategories[vChildren.id] &&
        mCategories[vChildren.id].appId !== libraryBookId
      ) {
        mCategories[vChildren.id].breadcrumb = [...item.breadcrumb, item.id];
        mCategories[vChildren.id].injected = true;
      }
    });
    item.children = [...item.virtualChildren];
    delete item.virtualChildren;
  });
};
